// @flow
import React from "react"
import { CardBrandWrap } from "./styled"
import Mastercard from "./Mastercard"
import Visa from "./Visa"
import { Text } from "componentsStyled/Typography/Texts"

const getIcon = (brand: string) => {
  if (brand === "Mastercard") return Mastercard
  if (brand === "Visa") return Visa
}

type Props = {|
  brand: string,
|}

const CardBrand = ({ brand }: Props) => {
  const Icon = getIcon(brand)

  return (
    <CardBrandWrap>
      {Icon && <Icon />}
      <Text book black>
        {brand}
      </Text>
    </CardBrandWrap>
  )
}

export default CardBrand



// WEBPACK FOOTER //
// ./src/pages/Account/Routes/Subpages/Payments/Content/CardBrand/index.js